import 'core-js/modules/es6.reflect.construct.js';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import 'core-js/modules/es6.array.map.js';
import * as React from 'react';
import { MenuItem, Classes, Menu } from '@blueprintjs/core';
import { DATERANGEPICKER_SHORTCUTS } from './common/classes.js';
import { isDayRangeInRange, clone } from './common/dateUtils.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Shortcuts = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Shortcuts, _React$PureComponent);

  var _super = _createSuper(Shortcuts);

  function Shortcuts() {
    var _this;

    _classCallCheck(this, Shortcuts);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getShorcutClickHandler = function (shortcut, index) {
      return function () {
        var onShortcutClick = _this.props.onShortcutClick;
        onShortcutClick(shortcut, index);
      };
    };

    _this.isShortcutInRange = function (shortcutDateRange) {
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate;
      return isDayRangeInRange(shortcutDateRange, [minDate, maxDate]);
    };

    return _this;
  }

  _createClass(Shortcuts, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var shortcuts = this.props.shortcuts === true ? createDefaultShortcuts(this.props.allowSingleDayRange, this.props.timePrecision !== undefined, this.props.useSingleDateShortcuts === true) : this.props.shortcuts;
      var shortcutElements = shortcuts.map(function (shortcut, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          active: _this2.props.selectedShortcutIndex === index,
          className: Classes.POPOVER_DISMISS_OVERRIDE,
          disabled: !_this2.isShortcutInRange(shortcut.dateRange),
          key: index,
          onClick: _this2.getShorcutClickHandler(shortcut, index),
          text: shortcut.label
        });
      });
      return /*#__PURE__*/React.createElement(Menu, {
        className: DATERANGEPICKER_SHORTCUTS,
        tabIndex: 0
      }, shortcutElements);
    }
  }]);

  return Shortcuts;
}(React.PureComponent);
Shortcuts.defaultProps = {
  selectedShortcutIndex: -1
};

function createShortcut(label, dateRange) {
  return {
    dateRange: dateRange,
    label: label
  };
}

function createDefaultShortcuts(allowSingleDayRange, hasTimePrecision, useSingleDateShortcuts) {
  var today = new Date();

  var makeDate = function makeDate(action) {
    var returnVal = clone(today);
    action(returnVal);
    returnVal.setDate(returnVal.getDate() + 1);
    return returnVal;
  };

  var tomorrow = makeDate(function () {
    return null;
  });
  var yesterday = makeDate(function (d) {
    return d.setDate(d.getDate() - 2);
  });
  var oneWeekAgo = makeDate(function (d) {
    return d.setDate(d.getDate() - 7);
  });
  var oneMonthAgo = makeDate(function (d) {
    return d.setMonth(d.getMonth() - 1);
  });
  var threeMonthsAgo = makeDate(function (d) {
    return d.setMonth(d.getMonth() - 3);
  });
  var sixMonthsAgo = makeDate(function (d) {
    return d.setMonth(d.getMonth() - 6);
  });
  var oneYearAgo = makeDate(function (d) {
    return d.setFullYear(d.getFullYear() - 1);
  });
  var twoYearsAgo = makeDate(function (d) {
    return d.setFullYear(d.getFullYear() - 2);
  });
  var singleDayShortcuts = allowSingleDayRange || useSingleDateShortcuts ? [createShortcut("Today", [today, hasTimePrecision ? tomorrow : today]), createShortcut("Yesterday", [yesterday, hasTimePrecision ? today : yesterday])] : [];
  return [].concat(singleDayShortcuts, [createShortcut(useSingleDateShortcuts ? "1 week ago" : "Past week", [oneWeekAgo, today]), createShortcut(useSingleDateShortcuts ? "1 month ago" : "Past month", [oneMonthAgo, today]), createShortcut(useSingleDateShortcuts ? "3 months ago" : "Past 3 months", [threeMonthsAgo, today])], _toConsumableArray(useSingleDateShortcuts ? [] : [createShortcut("Past 6 months", [sixMonthsAgo, today])]), [createShortcut(useSingleDateShortcuts ? "1 year ago" : "Past year", [oneYearAgo, today])], _toConsumableArray(useSingleDateShortcuts ? [] : [createShortcut("Past 2 years", [twoYearsAgo, today])]));
}

export { Shortcuts };
//# sourceMappingURL=shortcuts.js.map
